import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Component, ElementRef, ViewChild, Inject, OnInit } from '@angular/core';
import { Injectable, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


import { HttpClient } from '@angular/common/http';

import { ActivatedRoute } from '@angular/router';
import { SpinnerOverlayService } from '../../../../services/spinner-overlay.service';
import { UMPCategory, Utils } from '../../../../utils/utils';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';


interface DANode {
    groupId: string;
    groupName: string;
    subGroupsAllowed: boolean,
    selected?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    parent?: DANode;
    groups: DANode[]
}




@Component({
    selector: "group-daworkspace",
    templateUrl: './daworkspace.component.html',
    styleUrls: ['./daworkspace.component.less'],
    standalone: false
})

export class GroupDAWorkspace implements OnInit {
    userId = '';
    public TREE_DATA: DANode[] = [];/*** */
    dataCopy: any;

    public selectedNodes: string[] = [];

    public treeControl: NestedTreeControl<DANode>;
    public dataSource = new MatTreeNestedDataSource<DANode>();
    public rootNodes: any;
    public isExpanded = false;

    public searchString = '';
    public showOnlySelected = false;
    Tree_Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API
    isCallSucceed: number = 0;

    data: TreeManagement<UMPCategory> = {
        SelectedBranches: [],
        UnselectedBranches: [],
        UmpCategory: UMPCategory.DAnalyticsPowerBI
    }


    constructor(
        private toastrService: ToastrService,
        private route: ActivatedRoute,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private spinnerOverlayService: SpinnerOverlayService,
        private defaults: DefaultValuesService

    ) {
        this.treeControl = new NestedTreeControl<DANode>((node) => node.groups)
        defaults.resetBulkGroupTrigger$.subscribe(() => this.resetData())

    }
    ngOnInit() {
        this.userId = this.route.snapshot.paramMap.get('userId') || '';

        this.funcGetUserDataAnlytics();


    }

    public hasChild = (_: number, node: DANode) =>
        !!node.groups && node.groups.length > 0;

    private setParent(node: DANode, parent: DANode | undefined) {
        node.parent = parent;
        if (node.groups) {
            node.groups.forEach((childNode) => {
                this.setParent(childNode, node);
            });
        }
    }

    private checkAllParents(node: DANode) {
        if (node.parent) {
            const descendants = this.treeControl.getDescendants(node.parent);
            node.parent.indeterminate = descendants.some((child) => child.selected);
            this.checkAllParents(node.parent);
        }
    }

    public itemToggle(checked: boolean, node: DANode) {
        node.selected = checked;
        if (node.groups && checked) {
            node.indeterminate = false;
            this.itemUnselect(node);
        }
        if (node.groups) {
            this.itemDisable(checked, node);
        }
        if (checked) {
            this.data.UnselectedBranches = this.data.UnselectedBranches.filter(x => x !== node.groupId)
            this.data.SelectedBranches.push(node.groupId)
        }
        else {
            this.data.SelectedBranches = this.data.SelectedBranches.filter(x => x !== node.groupId)
            this.data.UnselectedBranches.push(node.groupId)
        }
        this.checkAllParents(node);
    }
    private itemUnselect(node: DANode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => { node.indeterminate = false; node.selected = false });
    }

    private itemDisable(checked: boolean, node: DANode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => node.disabled = checked);
    }

    public submit() {
        this.spinnerOverlayService.setFalseskipInterceptor()
        Utils.httpPostTreeGroupsByType(
            this.http
            , this.baseUrl
            , this.data
            , this.userId
            , this
            , function (tthis: GroupDAWorkspace, data: any) {
                tthis.data.SelectedBranches = []
                tthis.data.UnselectedBranches = []
                tthis.spinnerOverlayService.setTrueskipInterceptor()
                tthis.funcNotify();
                tthis.funcGetUserDataAnlytics();
            }
        )

    }

    public hideLeafNode(node: DANode): boolean {
        return new RegExp(this.searchString, 'i').test(node.groupName) === false;
    }


    public hideParentNode(node: DANode): boolean {
        if (
            !this.searchString ||
            node.groupName.toLowerCase().indexOf(this.searchString.toLowerCase()) !==
            -1
        ) {
            return false
        }
        const descendants = this.treeControl.getDescendants(node)

        if (
            descendants.some(
                (descendantNode) =>
                    descendantNode.groupName
                        .toLowerCase()
                        .indexOf(this.searchString.toLowerCase()) !== -1
            )
        ) {
            return false
        }

        return true
    }
    funcGetUserDataAnlytics() {
        this.Tree_Response_State = -2;
        this.isExpanded = false;

        Utils.httpGetDataAnlytics(
            this.http
            , this.baseUrl
            , this
            , (tthis: GroupDAWorkspace, data: any) => {
                this.assignValues(data);
                this.dataCopy = structuredClone(data);

            });
    }
    assignValues(data) {
        this.isExpanded = false;

        this.TREE_DATA = data.treeView; ///******** */
        //tthis.rootNode = data.treeView[0].groupName;
        this.selectedNodes = data.excludedPersonae;
        this.rootNodes = structuredClone(data.treeView);
        this.smallerTree(this.rootNodes);
    }
    resetData() {
        this.assignValues(structuredClone(this.dataCopy))
    }
    smallerTree(smallTREE_DATA) {
        smallTREE_DATA.forEach((parent) => {
            parent.groups?.forEach((child) => {
                delete child.groups;
            });
        });
        //smallTREE_DATA=smallTREE_DATA.flatMap((node) => node.children);
        this.treeControl.dataNodes = smallTREE_DATA;
        this.dataSource.data = smallTREE_DATA;
        Object.keys(this.dataSource.data).forEach((key) => {
            this.setParent(this.dataSource.data[key], undefined);

        })

    }
    longTreeExpandAll() {
        if (!this.isExpanded) {
            this.treeControl.dataNodes = this.TREE_DATA;
            this.dataSource.data = this.TREE_DATA;
            Object.keys(this.dataSource.data).forEach((key) => {
                this.setParent(this.dataSource.data[key], undefined);
            }
            )
            this.isExpanded = true;
        }

        
        this.treeControl.expandAll()
    }
   
    expandTriggered(name) {
        this.treeControl.dataNodes = this.TREE_DATA;
        this.dataSource.data = this.TREE_DATA;
        Object.keys(this.dataSource.data).forEach((key) => {
            this.setParent(this.dataSource.data[key], undefined);

        }
        )
        this.expandNodeByName(name);
        this.isExpanded = true;
        
    }
    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('DataAnalytics & PowerBI request not sent successfully !', 'Data Analytics and PowerBI Workspaces!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('DataAnalytics & PowerBI request not sent successfully !', 'Data Analytics and PowerBI Workspaces!');
        }
    }
    expandNodeByName(name: string) {
        const node = this.findNodeByName(this.treeControl.dataNodes, name);
        if (node) {
            this.treeControl.expand(node);
        }
    }

    findNodeByName(nodes: DANode[], name: string): DANode | undefined {
        for (const node of nodes) {
            if (node.groupName === name) {
                return node;
            }

        }
        return undefined;
    }

    itemSelected(ischecked, name, id) {
        if (ischecked) {
            this.onSelect(name, id);
        } else {
            this.onDeselect(name, id);
        }
    }

    onSelect(name, selectedid) {
        this.defaults.addGroupListItem({ Personae: name, Id: selectedid, UmpCategory: UMPCategory.DAnalyticsPowerBI });

    }

    onDeselect(name, selectedid) {
        this.defaults.removeGroupListItem(selectedid);

    }
}